import React from 'react';
import styled from 'styled-components';

const D7Style = styled.svg``;

export const D7 = ({ color }) => {
	return (
		<D7Style
			xmlns='http://www.w3.org/2000/svg'
			width='22.261'
			height='22.536'
			viewBox='0 0 22.261 22.536'
		>
			<path
				id='Suitcase'
				d='M789.2,404.007l-.015-.015a3.043,3.043,0,0,0-2.152-.9h-.72a.515.515,0,0,0-.07-.293l-2.145-3.716a.512.512,0,0,0-.683-.2v0l-4.829,2.553-4.371-2.522-.025-.018a.512.512,0,0,0-.7.188l-2.146,3.716a.515.515,0,0,0-.07.293h-.4a3.041,3.041,0,0,0-2.151.9l-.006,0a3.042,3.042,0,0,0-.894,2.152v12.168a3.04,3.04,0,0,0,.884,2.138l.01.013.006.006a3.051,3.051,0,0,0,2.151.9h16.16a3.061,3.061,0,0,0,3.051-3.052V406.146a3.044,3.044,0,0,0-.884-2.139Zm-5.742-3.98h0l1.771,3.069h-3.77l-1.822-1.049,3.822-2.02Zm-9.337.015h0q2.643,1.526,5.293,3.054H772.36l1.762-3.054Zm14.249,14.989h-6.456a.341.341,0,0,1-.24-.1v0a.325.325,0,0,1-.1-.237v-4.922a.333.333,0,0,1,.1-.24h0a.328.328,0,0,1,.24-.1h6.456v5.6Zm0-6.629h-6.456a1.349,1.349,0,0,0-.963.4l0,0a1.375,1.375,0,0,0-.4.963v4.922a1.364,1.364,0,0,0,.4.963l0,0a1.359,1.359,0,0,0,.963.4h6.456v2.254a1.35,1.35,0,0,1-1.337,1.34h-16.16a1.344,1.344,0,0,1-1.336-1.34V406.146a1.34,1.34,0,0,1,.39-.945l0,0a1.333,1.333,0,0,1,.942-.392h16.16a1.342,1.342,0,0,1,1.337,1.34V408.4Zm-4.828,5.362h0a2.169,2.169,0,0,0,3.1-3.038l-.027-.033a2.18,2.18,0,0,0-1.534-.632,2.146,2.146,0,0,0-1.5.608l-.033.024a2.174,2.174,0,0,0,0,3.071Zm.722-2.342h0l.025-.025a1.146,1.146,0,0,1,1.595.025l.021.021a1.142,1.142,0,0,1-.829,1.929,1.148,1.148,0,0,1-.812-.334h0a1.144,1.144,0,0,1,0-1.616Z'
				transform='translate(-767.824 -398.83)'
				fill={color}
			/>
		</D7Style>
	);
};
